import { useState, useEffect, useMemo, useContext } from 'react'
import { autorun } from 'mobx'
import { PrinterOutlined } from '@ant-design/icons'
import { EditContext } from 'src/components'
import { appStore } from 'src/stores'
import { getValidNavColumns } from 'src/components/root/helper'
import printJS from 'print-js'
import { get } from 'lodash'
import printcss from './print.css'
import 'src/styles/components/root/printer.less'

const count = 3

const PrintStandard = () => {
  const edit = useContext(EditContext)

  const handlePrint = () => {
    printJS({
      printable: 'printer-zone',
      type: 'html',
      maxWidth: 1200,
      targetStyles: ['*'],
      style: printcss
    })
  }

  const getFieldValue = (col: any, record?: any) => {
    const value = get(record || edit.formBase, col.FIELD_NAME)
    if (col.ENUM) return appStore.getEnumLabel(col.ENUM, value)
    if (typeof value === 'boolean') return value ? '是' : '否'
    return String(value ?? '/')
  }

  const pagerColumns = useMemo(() => {
    const targetColumns: any[] = []
    const rows = Math.ceil(edit.validNavColumns.length / count)
    for (let i = 0; i < rows; i++) {
      !targetColumns[i] && targetColumns.push([])
      targetColumns[i].push(...edit.validNavColumns.slice(i * count, (i + 1) * count))
    }
    return targetColumns
  }, [edit.validNavColumns])

  const [subTables, setSubTables] = useState<any[]>([])
  useEffect(() => autorun(() => {
    const { tables = {}, validTables = [] } = edit.editPageTable
    setSubTables(validTables.map((item: any) => {
      const { Nav_PageEdit, Nav_Columns } = item
      const columns = getValidNavColumns(Nav_Columns)
      const dataSource = tables[Nav_PageEdit.ID].visibleDataSource
      return { title: Nav_PageEdit.LABEL_NAME, columns, dataSource }
    }))
  }), [])

  return (
    <div className='printer'>
      <div id='printer-zone' className='printer__zone'>
        <h3 className='printer__zone-title'>{edit?.editConfig.Nav_Form.NAME}</h3>
        {
          pagerColumns.map((col, i) => {
            return (
              <table key={`table-${i}`} className={`combination ${i === 0 ? 'first' : ''}`}>
                <thead>
                  <tr>
                    {
                      col.map((item: any, index: number) => (
                        <th key={`th-${index}`} className='col8'>{item.LABEL}</th>
                      ))
                    }
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {
                      col.map((item: any, index: number) => (
                        <td key={`td-${index}`} className='col8'>{getFieldValue(item)}</td>
                      ))
                    }
                  </tr>
                </tbody>
              </table>
            )
          })
        }
        {
          subTables.map((item: any, index: number) => {
            return (
              <table key={`subtable-${index}`} className='seprate'>
                <thead>
                  <tr><th colSpan={item.columns.length} style={{ textAlign: 'center' }}>{item.title}</th></tr>
                  <tr>
                    {
                      item.columns.map((col: any, ci: number) => (
                        <th key={`subth-${ci}`}>{col.LABEL}</th>
                      ))
                    }
                  </tr>
                </thead>
                <tbody>
                  {
                    item.dataSource.map((data: any, di: number) => (
                      <tr key={`subtr-${di}`}>
                        {
                          item.columns.map((col: any, ci: number) => (
                            <td key={`subtd-${ci}`}>{getFieldValue(col, data)}</td>
                          ))
                        }
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            )
          })
        }
      </div>
      <div onClick={handlePrint} className='printer__btn'>
        <PrinterOutlined />
      </div>
    </div>
  )
}

export default PrintStandard